import { request } from "./client";
import type { TenantSettings } from "./types";

export async function getSettings(): Promise<TenantSettings> {
  return request<TenantSettings>({ method: "GET", url: "/settings" });
}
